export default "__VITE_ASSET__BiggdZwF__"